"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _default = function _default(Component) {
  var IMESafeComponent =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(IMESafeComponent, _React$Component);

    function IMESafeComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, IMESafeComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IMESafeComponent).call(this, props));
      _this.state = {
        composing: false
      };
      _this.handleCompositionStart = _this.handleCompositionStart.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleCompositionEnd = _this.handleCompositionEnd.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeyUp = _this.handleKeyUp.bind((0, _assertThisInitialized2.default)(_this));
      _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
      _this._refCallback = (0, _utils.makeDecoratorRefCallback)(Component, (0, _assertThisInitialized2.default)(_this));
      return _this;
    }

    (0, _createClass2.default)(IMESafeComponent, [{
      key: "handleCompositionStart",
      value: function handleCompositionStart(evt) {
        var onCompositionStart = this.props.onCompositionStart;
        if (onCompositionStart) onCompositionStart(evt);
        this.setState({
          composing: true
        });
      }
    }, {
      key: "handleCompositionEnd",
      value: function handleCompositionEnd(evt) {
        var onCompositionEnd = this.props.onCompositionEnd;
        if (onCompositionEnd) onCompositionEnd(evt);
        this.setState({
          composing: false
        });
      }
    }, {
      key: "handleKeyUp",
      value: function handleKeyUp(evt) {
        var onKeyUp = this.props.onKeyUp;

        if (this.state.composing) {
          evt.stopPropagation();
        } else if (onKeyUp) {
          onKeyUp(evt);
        }
      }
    }, {
      key: "handleKeyDown",
      value: function handleKeyDown(evt) {
        var onKeyDown = this.props.onKeyDown;

        if (this.state.composing) {
          evt.stopPropagation();
        } else if (onKeyDown) {
          onKeyDown(evt);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
          onCompositionStart: this.handleCompositionStart,
          onCompositionEnd: this.handleCompositionEnd,
          onKeyUp: this.handleKeyUp,
          onKeyDown: this.handleKeyDown,
          ref: this._refCallback
        }));
      }
    }]);
    return IMESafeComponent;
  }(_react.default.Component);

  IMESafeComponent.displayName = "IMESafe(" + (0, _getComponentName.default)(Component) + ")";
  IMESafeComponent.propTypes = Component.propTypes;
  IMESafeComponent.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(IMESafeComponent, Component);
  return IMESafeComponent;
};

exports.default = _default;
module.exports = exports.default;